module.exports = __webpack_public_path__ + "right-download-android-e33868e0.png";